import _get from 'lodash.get';
import { credentials } from '@shootsta/client-auth';



export default function ({ userId, firstName, lastName, imageUrl }) {
  const name = `${firstName} ${lastName}`;
  const currentUserId = _get(credentials.get(), 'user.userId', null);

  return { userId, name, imageUrl, isUser: currentUserId === userId };
}